import {
  BSC_TESTNET_CHAIN_CONFIG,
  BSC_TESTNET_CHAIN_ID_DECIMAL,
  BSC_TESTNET_CHAIN_ID_HEX,
  BSC_TESTNET_RPC_URLS,
  CHECK_IN_CONTRACT_ADDRESS_TESTNET,
} from './testnet';

export const IS_TESTNET = false;

// Mainnet Configuration
const BSC_MAINNET_CHAIN_ID_HEX = '0xcc';
const BSC_MAINNET_CHAIN_ID_DECIMAL = 204;
const BSC_MAINNET_CHAIN_NAME = 'opBNB Mainnet';
const BSC_MAINNET_NATIVE_CURRENCY = {
  name: 'BNB',
  symbol: 'BNB',
  decimals: 18,
};
const BSC_MAINNET_RPC_URLS = ['https://opbnb-mainnet-rpc.bnbchain.org'];
const BSC_MAINNET_BLOCK_EXPLORER_URLS = ['https://opbnbscan.com'];
const CHECK_IN_CONTRACT_ADDRESS_MAINNET =
  '0xa26E81627947FcF5C08E8d2b3D26e690ADFC4B99';

const BSC_MAINNET_CHAIN_CONFIG = {
  chainId: BSC_MAINNET_CHAIN_ID_HEX,
  chainName: BSC_MAINNET_CHAIN_NAME,
  nativeCurrency: BSC_MAINNET_NATIVE_CURRENCY,
  rpcUrls: BSC_MAINNET_RPC_URLS,
  blockExplorerUrls: BSC_MAINNET_BLOCK_EXPLORER_URLS,
};

export const BSC_CHAIN_ID_HEX = IS_TESTNET
  ? BSC_TESTNET_CHAIN_ID_HEX
  : BSC_MAINNET_CHAIN_ID_HEX;

export const BSC_CHAIN_ID_DECIMAL = IS_TESTNET
  ? BSC_TESTNET_CHAIN_ID_DECIMAL
  : BSC_MAINNET_CHAIN_ID_DECIMAL;

export const BSC_CHAIN_NAME = IS_TESTNET
  ? BSC_TESTNET_CHAIN_CONFIG.chainName
  : BSC_MAINNET_CHAIN_NAME;

export const BSC_NATIVE_CURRENCY = IS_TESTNET
  ? BSC_TESTNET_CHAIN_CONFIG.nativeCurrency
  : BSC_MAINNET_NATIVE_CURRENCY;

export const BSC_RPC_URLS = IS_TESTNET
  ? BSC_TESTNET_RPC_URLS
  : BSC_MAINNET_RPC_URLS;

export const BSC_BLOCK_EXPLORER_URLS = IS_TESTNET
  ? BSC_TESTNET_CHAIN_CONFIG.blockExplorerUrls
  : BSC_MAINNET_BLOCK_EXPLORER_URLS;

export const CHECK_IN_CONTRACT_ADDRESS = IS_TESTNET
  ? CHECK_IN_CONTRACT_ADDRESS_TESTNET
  : CHECK_IN_CONTRACT_ADDRESS_MAINNET;

export const BSC_CHAIN_CONFIG = IS_TESTNET
  ? BSC_TESTNET_CHAIN_CONFIG
  : BSC_MAINNET_CHAIN_CONFIG;

// Real BSC (BNB Smart Chain) EVM mainnet configuration (chainId 56)
export const BSC_EVM_MAINNET_CHAIN_ID_HEX = '0x38';
export const BSC_EVM_MAINNET_CHAIN_ID_DECIMAL = 56;
export const BSC_EVM_MAINNET_CHAIN_NAME = 'BNB Smart Chain';
export const BSC_EVM_MAINNET_NATIVE_CURRENCY = {
  name: 'BNB',
  symbol: 'BNB',
  decimals: 18,
};
export const BSC_EVM_MAINNET_RPC_URLS = [
  'https://bsc-mainnet.public.blastapi.io',
  'https://bsc-dataseed1.binance.org',
  'https://bsc-dataseed2.binance.org',
  'https://bsc.publicnode.com',
  'https://bsc-dataseed.binance.org',
];
export const BSC_EVM_MAINNET_BLOCK_EXPLORER_URLS = ['https://bscscan.com'];

export const BSC_EVM_MAINNET_CHAIN_CONFIG = {
  chainId: BSC_EVM_MAINNET_CHAIN_ID_HEX,
  chainName: BSC_EVM_MAINNET_CHAIN_NAME,
  nativeCurrency: BSC_EVM_MAINNET_NATIVE_CURRENCY,
  rpcUrls: BSC_EVM_MAINNET_RPC_URLS,
  blockExplorerUrls: BSC_EVM_MAINNET_BLOCK_EXPLORER_URLS,
};
